module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-reports"
  }, [_vm._m(0), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('MaintenanceRequestList', {
    attrs: {
      "filters": _vm.search,
      "listing-type": "detail-listing"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Maintenance Requests")])]), _c('div', {
    staticClass: "action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3453813b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleInterventionRequests.vue
// module id = 2395
// module chunks = 1